const MINUTES_PER_DAY = 24 * 60;

export const hhmmToMinutes = value => {
  if (value === undefined || value === null) {
    return null;
  }
  const str = String(value);
  const [hoursStr, minutesStr] = str.split(':');
  if (hoursStr === undefined || minutesStr === undefined) {
    return null;
  }
  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) {
    return null;
  }
  return hours * 60 + minutes;
};

export const minutesToHHMM = minutes => {
  if (minutes === null || minutes === undefined || Number.isNaN(minutes)) {
    return null;
  }
  const normalized = ((minutes % MINUTES_PER_DAY) + MINUTES_PER_DAY) % MINUTES_PER_DAY;
  const hrs = Math.floor(normalized / 60)
    .toString()
    .padStart(2, '0');
  const mins = (normalized % 60).toString().padStart(2, '0');
  return `${hrs}:${mins}`;
};

export const applyOffsetToTime = (timeStr, offsetMinutes = 0) => {
  if (!offsetMinutes) {
    return timeStr;
  }

  const minutes = hhmmToMinutes(timeStr);
  if (minutes === null) {
    return timeStr;
  }

  const adjusted = minutes + offsetMinutes;
  const adjustedStr = minutesToHHMM(adjusted);
  return adjustedStr || timeStr;
};
